import {useMemo, useRef} from 'react';
import {assert} from 'assert-ts';
import isEqual from 'lodash/isEqual';
import {useAppSelector} from 'store/hooks';
import type {WorkImportProps} from '../types';
import {selectMetadataEditExportsWork} from '../metadataEditSlice';

export const useWorkImportProps = (): WorkImportProps => {
  const workExports = useAppSelector(selectMetadataEditExportsWork);
  const exportsRef = useRef<WorkImportProps>(undefined);

  return useMemo(() => {
    const newExports = {
      work: workExports,
    };

    if (!isEqual(newExports, exportsRef.current)) {
      exportsRef.current = newExports;
    }

    return assert(exportsRef.current);
  }, [workExports]);
};
